var Backbone = require('backbone');

var PermissionModel = Backbone.Model.extend({

    defaults: {
        id: undefined,
        ownerId: undefined,
        organizationId: undefined,
        canRead: false,
        canWrite: false,
        canDelete: false,
        canSign: false,
        canSignAll: false,
        canUploadFor: false,
        canReadAll: false,
        canReadFor: false,
        canWriteFor: false,
        canChangeReviewer: false,
        canWriteAll: false
    },

    urlRoot: '/api/permission',

    initialize: function () {
        this.bind("change", this.attributesChanged);
    },

    attributesChanged: function () {
        var valid = false;
        if (this.get('permittedObjectId') && (this.get('ownerId') || this.get('organizationId')))
            valid = true;
        this.trigger("validated", valid);
    }
});


module.exports = PermissionModel;


//////////////////
// WEBPACK FOOTER
// ./app/models/permission-model.js
// module id = 244
// module chunks = 0